"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.richTextEditor = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const dictionary_1 = require("Views/Partials/Pages/ContactUsContentPage/dictionary");
const ContactFormService_1 = require("Views/Partials/Pages/ContactUsContentPage/ContactFormService");
const client_1 = require("react-dom/client");
const ContactForm_1 = require("Views/Partials/Pages/ContactUsContentPage/ContactForm");
class RichTextEditor extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.rte-default';
        this.removeContactForm = () => {
            this.root.unmount();
        };
    }
    OnInit() {
        this.root = (0, client_1.createRoot)(this.contactFormContainer);
        this.el.forEach((el) => {
            const rteElem = el;
            const links = rteElem.querySelectorAll('a');
            const externalLink = new app_1.ExternalLink(links);
            Array.from(links).forEach(l => l.setAttribute('style', 'display:inline-block'));
            externalLink.checkLinks();
        });
        this.setContactUsForm();
    }
    setContactUsForm() {
        try {
            if (document.body.dataset.contactUsForm) {
                const contactUsFormData = JSON.parse(document.body.dataset.contactUsForm);
                const container = document.createElement('div');
                container.id = 'contact-us-form-container';
                this.contactFormContainer = document.body.appendChild(container);
                const dictionary = (0, app_1.transformDictionary)(dictionary_1.contactUsContentPageDictionary, JSON.parse(contactUsFormData.dictionary));
                const culture = contactUsFormData.culture;
                const locationApiUrl = contactUsFormData.locationApiBaseUrl;
                const locationApiKey = contactUsFormData.locationApiKey;
                const formsServiceApiUrl = contactUsFormData.formServiceApiUrl;
                const contactsApiUrl = this.getContactsApiUrl(locationApiUrl);
                this.contactFormContainer = document.getElementById('contact-us-form-container');
                this.processContactUsFormLinks(culture, dictionary, locationApiUrl, formsServiceApiUrl, contactsApiUrl, locationApiKey);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    getContactsApiUrl(locationUrl) {
        const danfossLocationsApiPath = '/danfoss-location/danfosslocations';
        return `${locationUrl}${danfossLocationsApiPath}`;
    }
    processContactUsFormLinks(culture, dictionary, locationApiUrl, formsServiceApiUrl, contactsApiUrl, locationApiKey) {
        const contactUsFormLinks = document.querySelectorAll('button[data-type=contactUsForm]');
        const contactUsFormLinksCount = contactUsFormLinks.length;
        const contactFormService = new ContactFormService_1.ContactFormService(contactsApiUrl, locationApiKey);
        for (let i = 0; i < contactUsFormLinksCount; i++) {
            const link = contactUsFormLinks[i];
            const { contactId } = link.dataset;
            link.setAttribute('aria-haspopup', 'dialog');
            link.addEventListener('click', () => {
                this.root.render((0, jsx_runtime_1.jsx)(ContactForm_1.ContactForm, { contactId: contactId, culture: culture, dictionary: dictionary, locationApiUrl: locationApiUrl, formsServiceApiUrl: formsServiceApiUrl, contactFormService: contactFormService, onFormClose: this.removeContactForm }), this.contactFormContainer);
            });
        }
    }
}
exports.richTextEditor = new RichTextEditor();
